import { RouteRecordRaw } from 'vue-router'

const officeSurveysRoutes: RouteRecordRaw[] = [
  {
    path: '/office/surveys/schedule',
    name: 'office-surveys.schedule',
    component: () => import('@/modules/operations/views/Surveys/OfficeSurveyScheduleIndex.vue'),
    meta: {
      pageTitle: 'Office Surveys Schedule',
      breadcrumbs: ['Office Surveys', 'Schedule']
    }
  },
  {
    path: '/office/surveys/schedule/create',
    name: 'office-surveys.schedule.create',
    component: () => import('@/modules/operations/views/Surveys/OfficeSurveysEdit.vue'),
    meta: {
      pageTitle: 'Schedule Office Survey',
      breadcrumbs: ['Office Surveys Schedule', 'Schedule']
    }
  },
  {
    path: '/office/surveys/reports',
    name: 'office-surveys.reports',
    component: () => import('@/modules/operations/views/Surveys/OfficeSurveyReportsIndex.vue'),
    meta: {
      pageTitle: 'Office Surveys Reports',
      breadcrumbs: ['Office Surveys', 'Reports']
    }
  },
  {
    path: '/office/surveys/reports/create',
    name: 'office-surveys.reports.create',
    component: () => import('@/modules/operations/views/Surveys/OfficeSurveysEdit.vue'),
    meta: {
      pageTitle: 'Add Office Survey Report',
      breadcrumbs: ['Office Surveys Reports', 'Add Report']
    }
  },
  {
    path: '/office/surveys/:id/edit',
    name: 'office-surveys.edit',
    component: () => import('@/modules/operations/views/Surveys/OfficeSurveysEdit.vue'),
    meta: {
      pageTitle: 'Edit Office Survey',
      breadcrumbs: ['Office Surveys', 'Edit']
    }
  },
  {
    path: '/office/surveys/:id/show',
    name: 'office-surveys.show',
    component: () => import('@/modules/operations/views/Surveys/SurveysShow.vue'),
    meta: {
      pageTitle: 'Office Survey Details',
      breadcrumbs: ['Office Surveys', 'Details']
    }
  },
  // Legacy redirects
  {
    path: '/office/surveys',
    redirect: { name: 'office-surveys.schedule' }
  },
  {
    path: '/office/surveys/create',
    redirect: { name: 'office-surveys.reports.create' }
  }
]

export default officeSurveysRoutes
